// UTIL FILE WITH ABSTRACTED FUNCTIONS USED IN USEKEEPAWAKEWEB HOOK FILE
// TEMP FIX UNTIL THIS PR IS COMPLETE WITH EXPO: https://github.com/expo/expo/pull/9467
export enum KeepAwakeEventType {
  RELEASE = 'release',
}

const wakeLockMap: Record<string, any> = {};
export default {
  async isAvailableAsync() {
    return 'wakeLock' in navigator;
  },
  async activate(tag: string) {
    if (wakeLockMap[tag]) {
      console.warn(
        `ERROR TRYING TO ACTIVATE: KEEP_AWAKE_TAG_INVALID: The wake lock with tag ${tag} has not activated yet`,
      );
    }
    console.log('Activate screen wake lock');
    const wakeLock = await (navigator as any).wakeLock.request('screen');
    wakeLockMap[tag] = wakeLock;
  },
  async deactivate(tag: string) {
    if (wakeLockMap[tag]) {
      console.log('Deactiveate screen wake lock');
      wakeLockMap[tag].release().then(() => {
        wakeLockMap[tag] = null;
      });
    } else {
      console.warn(
        `ERROR TRYING TO DEACTIVATE: KEEP_AWAKE_TAG_INVALID: The wake lock with tag ${tag} has not activated yet`,
      );
    }
  },

  // ====== Usec to notify user if wake lock has been released =======
  addListener(tag: string, listener: (eventType: KeepAwakeEventType) => void) {
    if (wakeLockMap[tag]) {
      wakeLockMap[tag].addEventListener('release', () => {
        listener(KeepAwakeEventType.RELEASE);
      });
    }
  },
};
